module.exports = __webpack_public_path__ + "static/media/bath-ico.d9d4d466.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/bath-ico.png
// module id = 713
// module chunks = 0